export const AppRoutes = {
    home: '/home',
    inspections: '/inspections',
    inspectionMoveIn: '/inspections/move-in',
    inspectionMoveOut: '/inspections/move-out',
    inspectionPropertyDetail: '/inspections/property/:inspectionId',
    login: '/login',
    leases: '/leases',
    selectArea: '/select-area/:id',
    issues: '/issue',
    resetPassword: '/reset-password',
    viewServiceRequest: '/view-service-request/:id',
    createServiceRequest: '/create-service-request',
    reports: '/reports',
    managePayments: '/manage-payments',
    stripeCheckout: '/stripe-checkout',
    maintenance: '/maintenance',
    moveIn: '/move-in',
    billPay: '/bill-pay',
    damages: '/damages',
    moveOut: '/move-out',
    documents: '/documents',
    invoices: '/invoices',
    register: '/register',
    account: '/account',
    applicant: '/applicant',
    messages: '/messages',
    messageDetail: '/messages/:id',
    events: '/events',
    eventDetail: '/events/:id',
}

export const resolveRoute = (
    route: string,
    paramKey: string,
    paramValue: string | number,
) => {
    return route.replace(paramKey, paramValue.toString())
}
